import 'bootstrap/dist/css/bootstrap.css';
import './styles/tokens.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './AuthContext';
import { PlatformAccessProvider } from './access/PlatformAccess';
import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
      <AuthProvider>
        <PlatformAccessProvider>
          <App />
        </PlatformAccessProvider>
      </AuthProvider>
    </BrowserRouter>,
    rootElement);

registerServiceWorker();
